// ─── Feuille : fiche / édition d'un CONTACT ───────────────────────
// Formulaire du carnet partagé. Modèle multi-valeurs : plusieurs téléphones /
// emails TYPÉS (mobile/domicile/travail…) avec un principal, et plusieurs LIEUX
// du carnet (référence `lieuId`, jamais d'adresse copiée). Prénom OU nom requis.
import React, { useEffect, useMemo, useState } from 'react';
import { View, Text, TextInput, StyleSheet } from 'react-native';
import { Feuille, ChoixPuces, stylesForm, useUI, useT } from '@mop/core';
import { ROLES_CONTACT, TYPES_TEL, TYPES_EMAIL, normaliserTels, normaliserEmails, normaliserLieux, normaliserChamps, nouvelIdEntree } from './services/contacts';
import ChampsTypes from './ChampsTypes';
import ChampsLieux from './ChampsLieux';
import ChampsPerso from './ChampsPerso';

const avecId = (arr) => arr.map(e => ({ ...e, id: e.id || nouvelIdEntree() }));

export default function FeuilleContact({ visible, initial, lieux = [], onDemanderDate, onDemanderLieu,
  onDemanderHeure, onDemanderChoix, onEnregistrer, onFermer }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);
  const [f, setF] = useState(null);

  useEffect(() => {
    if (!visible) return;
    const c = initial || {};
    setF({
      prenom: c.prenom || '', nom: c.nom || '', surnom: c.surnom || '', role: c.role || 'autre',
      telephones: avecId(normaliserTels(c)), emails: avecId(normaliserEmails(c)),
      lieux: normaliserLieux(c), champs: normaliserChamps(c), note: c.note || '',
    });
  }, [visible, initial]);

  if (!f) return null;
  const set = (k, v) => setF(x => ({ ...x, [k]: v }));
  const modifie = !!((f.prenom || '').trim() || (f.nom || '').trim());

  return (
    <Feuille visible={visible} titre={initial?.id ? t('contacts.modifier') : t('contacts.nouveau')}
      emoji="👤" hauteur={0.85} onFermer={onFermer}
      action={{ icone: initial?.id ? '💾' : '＋', label: t('commun.enregistrer'), disabled: !modifie, onPress: () => onEnregistrer(f) }}>
      <View style={s.row}>
        <View style={{ flex: 1 }}>
          <Text style={s.lbl}>{t('contacts.prenom')}</Text>
          <TextInput style={s.input} value={f.prenom} onChangeText={v => set('prenom', v)}
            placeholder={t('contacts.phPrenom')} placeholderTextColor={UI.faint} />
        </View>
        <View style={{ flex: 1 }}>
          <Text style={s.lbl}>{t('contacts.nom')}</Text>
          <TextInput style={s.input} value={f.nom} onChangeText={v => set('nom', v)}
            placeholder={t('contacts.phNom')} placeholderTextColor={UI.faint} />
        </View>
      </View>
      <Text style={s.lbl}>{t('contacts.surnom')}</Text>
      <TextInput style={s.input} value={f.surnom} onChangeText={v => set('surnom', v)}
        placeholder={t('contacts.phSurnom')} placeholderTextColor={UI.faint} />

      <Text style={s.lbl}>{t('contacts.categorie')}</Text>
      <ChoixPuces options={ROLES_CONTACT.map(r => ({ id: r.id, label: `${r.emoji} ${r.label}` }))}
        value={f.role} onChange={v => set('role', v)} />

      <ChampsTypes titre={t('contacts.telephones')} entries={f.telephones} types={TYPES_TEL}
        clavier="phone-pad" placeholder={t('contacts.phTelephone')} ajouterLabel={t('contacts.ajouterTel')}
        onChange={v => set('telephones', v)} />
      <ChampsTypes titre={t('contacts.emails')} entries={f.emails} types={TYPES_EMAIL}
        clavier="email-address" placeholder={t('contacts.phEmail')} ajouterLabel={t('contacts.ajouterEmail')}
        onChange={v => set('emails', v)} />
      <ChampsLieux entries={f.lieux} lieux={lieux} onChange={v => set('lieux', v)} onDemanderLieu={onDemanderLieu} />
      <ChampsPerso entries={f.champs} onChange={v => set('champs', v)} onDemanderDate={onDemanderDate}
        onDemanderHeure={onDemanderHeure} onDemanderChoix={onDemanderChoix} />

      <Text style={s.lbl}>{t('contacts.note')}</Text>
      <TextInput style={[s.input, { minHeight: 60 }]} value={f.note} onChangeText={v => set('note', v)}
        multiline placeholder={t('contacts.phNote')} placeholderTextColor={UI.faint} />
    </Feuille>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  ...stylesForm(UI),
  row: { flexDirection: 'row', gap: 8 },
});
